symbolWinBorderAnim = {};
symbolWinBorderAnim.reels = 5;
symbolWinBorderAnim.row = 5;
symbolWinBorderAnim.data = [];
symbolWinBorderAnim.callback;
symbolWinBorderAnim.listeningForUpdates = false;

//////////////////////////////////////////////////////
symbolWinBorderAnim.create = function (json) {
  return new PIXI.Container();
};

//////////////////////////////////////////////////////
symbolWinBorderAnim.initialise = function (json, container, resources) {
  symbolWinBorderAnim.container = container;

  for (let i = 0; i < symbolWinBorderAnim.reels; i++) {
    var rowList = [];

    for (let j = 0; j < symbolWinBorderAnim.row; j++) {
      // we have 2 anims, because this anim doesnt loop
      // so we have the 1st part of the anim frame 0 - 25
      // once we get to 25 on the 1st anim, we will start the second anim going
      // and we keep fading between the 2 anims, which allows this non looping anim to loop
      const symbol = {};
      symbol.animation1 = resourceManager.createObject(
        'movie',
        'symbolBorderAnim1_' + i + '_' + j,
        symbolWinBorderAnim.container,
        { definition: 'symbolWin_md', x: 0, y: 0, loop: true }
      );
      symbol.animation1.gotoAndStop(0);
      symbol.animation1.scale.set(2);
      symbol.animation1.visible = false;
      symbol.animation2 = resourceManager.createObject(
        'movie',
        'symbolBorderAnim2_' + i + '_' + j,
        symbolWinBorderAnim.container,
        { definition: 'symbolWin_md', x: 0, y: 0, loop: true }
      );
      symbol.animation2.gotoAndStop(0);
      symbol.animation2.scale.set(2);
      symbol.animation2.visible = false;

      rowList.push(symbol);
    }
    symbolWinBorderAnim.data.push(rowList);
  }

  messageBus.subscribe('spinner:GameConfigEvent', symbolWinBorderAnim.onLayoutComplete);
};

//////////////////////////////////////////////////////
symbolWinBorderAnim.onLayoutComplete = function () {
  Reflex.registerEventHandler('orientationChange', symbolWinBorderAnim.onOrientationChange);
};

//////////////////////////////////////////////////////
symbolWinBorderAnim.playAnimation = function (sequence, callback) {
  symbolWinBorderAnim.callback = callback;

  const anims = [];
  for (let i = 0; i < sequence.length; i++) {
    const { reel, row } = sequence[i];

    const xPos = gameData.reels[reel].position.getX();
    const yPos = gameData.reels[reel].position.getY() + row * 126;
    const anim1 = symbolWinBorderAnim.data[reel][row].animation1;
    const anim2 = symbolWinBorderAnim.data[reel][row].animation2;
    anim1.position.set(xPos, yPos);
    anim2.position.set(xPos, yPos);
    anim1.presentationState = 'intro';
    anim1.visible = true;
    anim1.loop = false;
    anim1.alpha = 0;
    anim1.onFrameChange = (currentFrame) => {
      symbolWinBorderAnim.onAnim1FrameChange(currentFrame, symbolWinBorderAnim.data[reel][row]);
    };
    anim2.onFrameChange = (currentFrame) => {
      symbolWinBorderAnim.onAnim2FrameChange(currentFrame, symbolWinBorderAnim.data[reel][row]);
    };

    anim1.play();
    anims.push(anim1);
  }

  // if these are now going to loop all the time, then we dont need to listen for updates
  // if (!symbolWinBorderAnim.listeningForUpdates) {
  //   symbolWinBorderAnim.listeningForUpdates = true;
  //   Reflex.addToUpdate(symbolWinBorderAnim.update);
  // }

  return anims;
};

symbolWinBorderAnim.onAnim1FrameChange = function (currentFrame, data) {
  // where are we on the anim?
  // is it time to start fading out?
  const anim1 = data.animation1;
  const anim2 = data.animation2;
  let frameCheck = 25;
  if (anim1.presentationState !== 'intro') {
    frameCheck = 50;
  }

  if (currentFrame >= frameCheck) {
    // we need to start anim2
    if (anim2.playing !== true) {
      // we need to start it
      anim2.visible = true;
      anim2.loop = false;
      anim2.alpha = 0;
      anim2.gotoAndPlay(30);
      // now we need to fade 1 out and fade 2 in
      anim2.fadeTween = gsap.fromTo(
        anim2,
        {
          alpha: 0,
        },
        {
          alpha: 1,
          duration: 0.187,
        }
      );
      anim1.fadeTween = gsap.fromTo(
        anim1,
        {
          alpha: 1,
        },
        {
          alpha: 0,
          delay: 0.187,
          duration: 0.187,
          onComplete: () => {
            anim1.presentationState = '';
            anim1.gotoAndStop(0);
            anim1.visible = false;
          },
        }
      );
    }
  }
};

symbolWinBorderAnim.onAnim2FrameChange = function (currentFrame, data) {
  const anim1 = data.animation1;
  const anim2 = data.animation2;

  if (currentFrame >= 50) {
    // we need to start anim1
    if (anim1.playing !== true) {
      // we need to start it
      anim1.visible = true;
      anim1.loop = false;
      anim1.alpha = 0;
      anim1.gotoAndPlay(30);
      // now we need to fade 1 out and fade 2 in
      anim1.fadeTween = gsap.fromTo(
        anim1,
        {
          alpha: 0,
        },
        {
          alpha: 1,
          duration: 0.187,
        }
      );
      anim2.fadeTween = gsap.fromTo(
        anim2,
        {
          alpha: 1,
        },
        {
          alpha: 0,
          delay: 0.187,
          duration: 0.187,
          onComplete: () => {
            anim2.gotoAndStop(0);
            anim2.visible = false;
          },
        }
      );
    }
  }
};

//////////////////////////////////////////////////////
symbolWinBorderAnim.onOrientationChange = function () {
  // is this really required if they are assigned to the correct parent?
  // for (let i = 0; i < symbolWinBorderAnim.reels; i++) {
  //   for (let j = 0; j < symbolWinBorderAnim.row; j++) {
  //     const reel = i;
  //     const row = j;
  //     const xPos = gameData.reels[reel].position.getX();
  //     const yPos = gameData.reels[reel].position.getY() + row * 126;
  //     symbolWinBorderAnim.data[reel][row].animation.position.set(xPos, yPos);
  //   }
  // }
};

//////////////////////////////////////////////////////
symbolWinBorderAnim.stopAllAnimations = function () {
  for (let i = 0; i < symbolWinBorderAnim.reels; i++) {
    for (let j = 0; j < symbolWinBorderAnim.row; j++) {
      // we should be ok to let any of the fade tweens to expire, as all they do
      // is hide stuff
      const data = symbolWinBorderAnim.data[i][j];
      data.animation1.visible = false;
      data.animation1.gotoAndStop(0);
      data.animation2.visible = false;
      data.animation2.gotoAndStop(0);
    }
  }

  // Reflex.removeFromUpdate(symbolWinBorderAnim.update);
  // symbolWinBorderAnim.listeningForUpdates = false;
  if (symbolWinBorderAnim.callback) {
    symbolWinBorderAnim.callback();
  }
};

// //////////////////////////////////////////////////////
// symbolWinBorderAnim.update = function () {
//   // now we are going to have these loop all the time, this check below is
//   // redundant
//   // the gameController or something is going to need to call stopAllAnimations when
//   // its ready
//   let allAnimationsEnded = true;

//   for (let reel = 0; reel < symbolWinBorderAnim.data.length; reel++) {
//     for (let row = 0; row < symbolWinBorderAnim.data[reel].length; row++) {
//       if (symbolWinBorderAnim.data[reel][row].animation.playing) {
//         allAnimationsEnded = false;
//       }
//     }
//   }

//   if (allAnimationsEnded) {
//     symbolWinBorderAnim.stopAllAnimations();
//   }
// };

//////////////////////////////////////////////////////
symbolWinBorderAnim.getFilesRequired = function (json) {
  return [];
};

//////////////////////////////////////////////////////
resourceManager.registerObjectType(
  'symbolWinBorderAnim',
  symbolWinBorderAnim.create,
  symbolWinBorderAnim.initialise,
  symbolWinBorderAnim.getFilesRequired
);
